import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryKeys';
import type { NormalizedApiError } from '@/services/types';
import { tenantApi } from '../api/tenantApi';
import type { CreateTenantInput, Tenant, UpdateTenantInput } from '../types';

function useInvalidateTenants() {
	const queryClient = useQueryClient();
	return () =>
		queryClient.invalidateQueries({ queryKey: queryKeys.tenants.all });
}

export function useCreateTenant() {
	const invalidate = useInvalidateTenants();

	return useMutation<Tenant, NormalizedApiError, CreateTenantInput>({
		mutationFn: (input) => tenantApi.create(input),
		onSuccess: invalidate,
	});
}

export function useUpdateTenant() {
	const invalidate = useInvalidateTenants();

	return useMutation<
		Tenant,
		NormalizedApiError,
		{ id: string; input: UpdateTenantInput }
	>({
		mutationFn: ({ id, input }) => tenantApi.update(id, input),
		onSuccess: invalidate,
	});
}
